module.exports = __webpack_public_path__ + "img/9788993094411.b1c7b76d.jpg";